import { PAGINEDETAIL, TEMI } from 'utils/endpoint'
import React from 'react'
import Breadcrumbs from 'components/atomic/Breadcrumbs'
import Icon from 'components/atomic/Icon'
import Link from 'next/link'
import MetaSeo from 'components/atomic/MetaSeo'
import Trans from 'components/atomic/Trans'
import { api } from 'utils'
import { sendGTMData } from 'utils/gtm'

const groups = (temi) => {
  const xywk = 'XYWK'
  const data = temi.reduce((accumulator, tema) => {
    let lettera = tema.titolo[0]

    if (xywk.includes(lettera)) {
      lettera = xywk
    }

    if (!accumulator[lettera]) {
      accumulator[lettera] = { lettera, children: [tema] }
    } else {
      accumulator[lettera].children.push(tema)
    }
    return accumulator
  }, {})

  const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  const dataKeys = Object.keys(data)
  alphabet.split('').forEach((lettera) => {
    if (!dataKeys.includes(lettera) && !xywk.includes(lettera)) {
      data[lettera] = { lettera, children: [] }
    }
  })
  if (!dataKeys.includes(xywk)) {
    data[xywk] = { lettera: xywk, children: [] }
  }

  return Object.values(data).sort((a, b) => {
    if (a.lettera < b.lettera) return -1
    if (a.lettera > b.lettera) return 1
    return 0
  })
}

const TemiAll = ({ temi, pagina }) => {
  const handleGTM = (itemTitle) => {
    if (itemTitle) {
      sendGTMData({
        event: 'GAevent',
        eventID: '02',
        eventCategory: 'menu_vedi_tutti',
        eventAction: 'temi',
        eventLabel: itemTitle.toGTMFormat(),
      })
    }
  }

  return (
    <>
      <MetaSeo seo={pagina.seo} />

      <main className="temi-all">
        <div className="w-container">
          <Breadcrumbs breadcrumbs={pagina.breadcrumbs} />

          <section className="temi-all__header">
            <h1 className="temi-all__header__title heading1">{pagina.titolo}</h1>

            <Link legacyBehavior href="/temi">
              <a className="temi-all__header__cta button button--tertiary">
                <Trans chiave="temi-all-header_cta Vedi tutti i temi in evidenza" />{' '}
                <Icon id="arrow-right" classes="button__arrow" />
              </a>
            </Link>
          </section>

          <section className="temi-all__list">
            {groups(temi).map((group) => (
              <ul
                key={group.lettera}
                className={`temi-all__item ${
                  group.children.length ? '' : 'temi-all__item--disabled'
                }`}
                aria-label={group.lettera?.capitalize()}
              >
                {group.children.map((child) => (
                  <li key={child.id}>
                    <Link legacyBehavior href={child.url}>
                      <a onClick={() => handleGTM(child.titolo)}>
                        {child.titolo?.capitalize()}
                        <Icon id="arrow-right" classes="temi-all__item-arrow" />
                      </a>
                    </Link>
                  </li>
                ))}
              </ul>
            ))}
          </section>
        </div>
      </main>
    </>
  )
}

export const getStaticProps = async () => {
  const response = await api.get(TEMI)
  const temi = response.data

  const pageResponse = await api.get(PAGINEDETAIL, {
    params: {
      chiave: 'temi-all',
    },
  })
  const pagina = await pageResponse.data

  const toolbarProps = { toolbarPage: pagina }

  return { props: { temi, pagina, ...toolbarProps }, revalidate: 60 * 5 }
}

export default TemiAll
